var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { search_result } = options; 
__p+='\n';
 if(search_result && search_result.title && search_result.top_markets) { 
__p+='\n    <div class="row">\n      <div class="col-xxs-12">\n        <h2>'+
((__t=( search_result.title ))==null?'':__t)+
'</h2>\n      </div>\n        <div class="col-xxs-12 col-xs-6 col-md-4 font-size-small">\n          <ul class="list-unstyled link-secondary">\n            ';
 search_result.top_markets.forEach ((value, index) => { 
__p+='\n              <li>\n                <a href= '+
((__t=( value['url'] ))==null?'':__t)+
' > '+
((__t=( value['city'] ))==null?'':__t)+
' Homes for Sale </a>\n              </li>\n              ';
 if (index % 2 != 0)  { 
__p+='\n          </ul>\n        </div>\n        <div class="col-xxs-12 col-xs-6 col-md-4 font-size-small">\n          <ul class="list-unstyled link-secondary">\n              ';
 } 
__p+='\n            ';
 }) 
__p+='\n          </ul>\n        </div>\n    </div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./srp/views/seo_widgets/templates/top_cities_in_srp.jst.ejs